import React from 'react';
import '../scss/layout/_footer.scss';
const Footer = () => <footer style={{zIndex:'-1'}} className="l-footer">Copyrights © 2018 Liang-Shi-Shu Inc. All rights reserved.</footer>
export default Footer;